import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import Unit from "@/model/Unit";
import Paging, {BasePqForm} from "biz-ts/src/api/Paging";

@Singleton
export default abstract class UnitApi {
    abstract list(): Promise<Array<Unit>>

    abstract paging(form: UpagingForm): Promise<Paging<Unit>>

    abstract create(form: UcreateForm): Promise<void>

    abstract edit(form: UeditForm): Promise<void>

    abstract delete(id: number): Promise<void>
}

class UnitApiImpl extends BaseApi implements UnitApi {

    protected urlPrefix = 'unit'

    list(): Promise<Array<Unit>> {
        return this.axios.get('list')
    }

    paging(form: UpagingForm): Promise<Paging<Unit>> {
        return this.axios.get('paging', {params: form})
    }

    create(form: UcreateForm): Promise<void> {
        return this.axios.post('create', form)
    }

    edit(form: UeditForm): Promise<void> {
        return this.axios.post('edit', form)
    }

    delete(id: number): Promise<void> {
        return this.axios.post('delete', {id: id})
    }
}

Container.bind(UnitApi).to(UnitApiImpl)

export class UpagingForm extends BasePqForm {
    name?: string
    symbol?: string
}

export class UcreateForm {
    name!: string
    symbol!: string
}

export class UeditForm {
    id!: number
    name!: string
    symbol!: string
}
